// extracted by mini-css-extract-plugin
export default {"text":"UsedSpacePostpaidModalThanks__text--1xpc8"};